import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { NexusQueriesService } from '@services/queries/services/nexus-queries.service';
import { meTeamQuery } from '@services/queries/queries/users.queries';
import { map } from 'rxjs/operators';

export const teamProfileOverviewResolver: ResolveFn<number> = () => {
  const nexusQueriesService = inject(NexusQueriesService);
  return nexusQueriesService
    .getMe(meTeamQuery)
    .pipe(map(({ teams }) => teams[0].id));
};
